import React from "react";
import PropTypes from "prop-types";
import {
  CaseStudyStatsContainer,
  CaseStudyStatContainer,
  NumberStyled,
  TextStyled,
} from "./CaseStudyStats.styled";
import { useTranslation } from "react-i18next";

const CaseStudyStats = (props) => {
  const { t } = useTranslation();
  return (
    <CaseStudyStatsContainer>
      {props.data?.map((item, index) => (
        <CaseStudyStatContainer key={index}>
          <NumberStyled>{t(item.number)}</NumberStyled>
          <TextStyled>{t(item.text)}</TextStyled>
        </CaseStudyStatContainer>
      ))}
    </CaseStudyStatsContainer>
  );
};

CaseStudyStats.propTypes = {
  children: PropTypes.node,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ),
};
export default CaseStudyStats;
